export const configuration = (state = {}, action) => {
  switch (action.type) {
    case 'SET_CONFIGURATION':
      return action.configuration;
    default:
      return state;
  }
};

export const getConfiguration = (state) => state;
